import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const sorted = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
  const latest = sorted.slice(0, 6);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm mt-2">热门作品最新章节同步上线</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {latest.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex gap-4 p-4 rounded-xl bg-white border border-background-200/70 hover:border-primary-200 hover:shadow-sm transition-all duration-300"
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 最新更新`}
                  title={`${comic.title} - 韩漫在线`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="text-foreground-900 font-semibold text-sm line-clamp-1 group-hover:text-primary-500 transition-colors">
                    {comic.title}
                  </h3>
                  <p className="text-foreground-400 text-xs mt-1 line-clamp-2">{comic.description}</p>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex flex-wrap gap-1.5">
                    {comic.tags.slice(0, 2).map((tag, i) => (
                      <span key={i} className="text-[10px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <span className="text-foreground-400 text-[10px] whitespace-nowrap">
                    更新于 {comic.updatedAt}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}